import { render, staticRenderFns } from "./AddPerson2.vue?vue&type=template&id=3332b964&scoped=true&"
import script from "./AddPerson2.vue?vue&type=script&lang=js&"
export * from "./AddPerson2.vue?vue&type=script&lang=js&"
import style0 from "./AddPerson2.vue?vue&type=style&index=0&id=3332b964&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3332b964",
  null
  
)

export default component.exports